import * as React from "react";
import { useRemoteComponents } from "./internal/provider.js";
export function createBreadcrumbGroupLoader({ Fallback, Skeleton }) {
    return function BreadcrumbGroupLoader(props) {
        const components = useRemoteComponents({ BreadcrumbGroup: Fallback });
        return components.BreadcrumbGroup ? React.createElement(components.BreadcrumbGroup, { ...props }) : React.createElement(Skeleton, { ...props });
    };
}
